/* Wall Blush — AI image mark. Tags any <img> whose alt starts with "AI:" (or whose
   file is a Higgsfield hf_ render) with a small "AI" badge. Loaded from theme.liquid. */
(function(){
  var SEL='img';
  function isAI(img){
    var alt=(img.getAttribute('alt')||'').trim();
    if(/^AI:/i.test(alt)) return true;
    var src=img.currentSrc||img.getAttribute('src')||img.getAttribute('data-src')||img.getAttribute('srcset')||'';
    if(/\/files\/hf_\d{8}_/i.test(src)) return true;
    var pic=img.parentElement; if(pic&&pic.tagName==='PICTURE'){ var ss=Array.prototype.map.call(pic.querySelectorAll('source'),function(s){return s.getAttribute('srcset')||'';}).join(' '); if(/\/files\/hf_\d{8}_/i.test(ss)) return true; }
    return false;
  }
  function mark(img){
    if(img.dataset.wbAi) return;
    if(!isAI(img)) return;
    img.dataset.wbAi='1';
    var host=img.parentElement;
    if(!host) return;
    // <picture>: never wrap the img (breaks source selection); badge the picture's container instead.
    if(host.tagName==='PICTURE'){ host=host.parentElement; if(!host) return;
      if(getComputedStyle(host).position==='static') host.style.position='relative';
      if(!host.querySelector(':scope > .wb-ai-badge')){ var pb=document.createElement('span'); pb.className='wb-ai-badge'; pb.textContent='AI';
        pb.setAttribute('title','Created with AI. The wallpaper print is real.'); pb.setAttribute('aria-label','Created with AI. The wallpaper print is real.'); host.appendChild(pb); }
      return; }
    // Reuse the parent when it already positions; otherwise wrap.
    var cs=getComputedStyle(host);
    if(cs.position==='static' && host.children.length===1){ host.style.position='relative'; }
    else if(host.children.length!==1){
      var w=document.createElement('span'); w.className='wb-ai-wrap';
      host.insertBefore(w,img); w.appendChild(img); host=w;
    }
    if(host.querySelector(':scope > .wb-ai-badge')) return;
    var b=document.createElement('span');
    b.className='wb-ai-badge'; b.textContent='AI';
    b.setAttribute('title','Created with AI. The wallpaper print is real.');
    b.setAttribute('aria-label','Created with AI. The wallpaper print is real.');
    host.appendChild(b);
  }
  function scan(root){ (root||document).querySelectorAll(SEL).forEach(mark); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){scan();}); else scan();
  new MutationObserver(function(muts){
    muts.forEach(function(m){ m.addedNodes.forEach(function(n){
      if(n.nodeType!==1) return;
      if(n.matches&&n.matches(SEL)) mark(n); else scan(n);
    });});
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
